import { GatewayStatus, useGateway } from '@civic/solana-gateway-react';
import { useEffect, useState } from 'react';
import { CandyMachineAccount } from './candy-machine';
import { MintButtonStyled } from './styles';

export const MintButton = ({
  onMint,
  candyMachine,
  isMinting,
}: {
  onMint: () => Promise<void>;
  candyMachine?: CandyMachineAccount;
  isMinting: boolean;
}) => {
  const { requestGatewayToken, gatewayStatus } = useGateway();
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (gatewayStatus === GatewayStatus.ACTIVE && clicked) {
      onMint();
      setClicked(false);
    }
  }, [gatewayStatus, clicked, setClicked, onMint]);

  const getMintButtonContent = () => {
    if (candyMachine?.state.isSoldOut) {
      return 'SOLD OUT';
    } else if (isMinting) {
      return 'Minting..';
    } else if (candyMachine?.state.isPresale) {
      return 'PRESALE RIFT';
    } else if (clicked && candyMachine?.state.gatekeeper) {
      return 'Loading..';
    }

    return 'Mint';
  };

  return (
    <MintButtonStyled
      style={{ fontSize: '35px' }}
      disabled={true}
      // disabled={
      //   clicked ||
      //   candyMachine?.state.isSoldOut ||
      //   isMinting ||
      //   !candyMachine?.state.isActive
      // }
      // onClick={async () => {
      //   setClicked(true);
      //   if (candyMachine?.state.isActive && candyMachine?.state.gatekeeper) {
      //     if (gatewayStatus === GatewayStatus.ACTIVE) {
      //       setClicked(true);
      //     } else {
      //       await requestGatewayToken();
      //     }
      //   } else {
      //     await onMint();
      //     setClicked(false);
      //   }
      // }}
    >
      {getMintButtonContent()}
    </MintButtonStyled>
  );
};
